module.exports = __webpack_public_path__ + "img/accel.67b4917d.svg";